/**
 * Admin, Fax, Document routing: where each fax type is filed for the agency.
 *
 * Each call throws on an error status, and on a response with no body, so the
 * caller's catch is the only failure path.
 */
import {
  listFaxRouteSettingsFaxRouteSettingsGet,
  resetFaxRouteOverrideFaxRouteSettingsFaxTypeIdDelete,
  saveFaxRouteOverrideFaxRouteSettingsFaxTypeIdPut,
} from './api/sdk.gen';
import type {
  FaxRouteOverrideBody,
  FaxRouteSettingRow,
  FaxRouteSettingsResponse,
  MiscTaskTypeId,
} from './api/types.gen';

export type {
  FaxRouteOverrideBody,
  FaxRouteSettingRow,
  FaxRouteSettingsResponse,
  MiscTaskTypeId,
};

function required<T>(data: T | undefined): T {
  if (!data) throw new Error('Fax routing response carried no data');
  return data;
}

export async function getFaxRouteSettings(): Promise<FaxRouteSettingsResponse> {
  const result = await listFaxRouteSettingsFaxRouteSettingsGet({
    throwOnError: true,
  });
  return required(result.data);
}

export async function saveFaxRouteOverride(
  faxTypeId: string,
  body: FaxRouteOverrideBody
): Promise<FaxRouteSettingRow> {
  const result = await saveFaxRouteOverrideFaxRouteSettingsFaxTypeIdPut({
    path: { fax_type_id: faxTypeId },
    body,
    throwOnError: true,
  });
  return required(result.data);
}

export async function resetFaxRouteOverride(
  faxTypeId: string
): Promise<FaxRouteSettingRow> {
  const result = await resetFaxRouteOverrideFaxRouteSettingsFaxTypeIdDelete({
    path: { fax_type_id: faxTypeId },
    throwOnError: true,
  });
  return required(result.data);
}
